import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { SharedService } from '@app/shared.module';
import { LoginService } from '@app/login.module/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public isLogin = true;
  public isForgotPassword = false;
  public isSignUp = false;
  public errorMessage: string;
  public isSubmitted = false;
  public token: string;
  public links: string[];

  constructor(private fb: FormBuilder, private loginService: LoginService, private router: Router,
    private sharedService: SharedService, private route: ActivatedRoute) {
    this.token = this.route.snapshot.queryParams['token'];
    sessionStorage.setItem('token', this.token);
    if (this.token === null || this.token === undefined) {
      this.errorMessage = 'Token must be present in url';
    }
  }

  ngOnInit() {
    this.sharedService.clearSession();
    this.loginForm = this.fb.group({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  login() {
    if (this.loginForm.valid) {
      const data = {
        userName: this.loginForm.controls.username.value,
        password: this.loginForm.controls.password.value,
        token: this.token,
        grant_type: 'password'
      };

      this.loginService.login(data).subscribe(resp => {
        if (resp && resp != null) {
          this.errorMessage = '';
          sessionStorage.setItem('UserName', resp['userName']);
          sessionStorage.setItem('isAdmin', resp['isAdmin']);
          this.sharedService.allowedAccess = resp['access'];
          const expiryDate = new Date(Date.now());
          expiryDate.setSeconds(expiryDate.getSeconds() + (resp['expires_in'] - 10));
          sessionStorage.setItem('token_expires_date', expiryDate.toString());

          sessionStorage.setItem('bearer-token', resp.access_token);
          sessionStorage.setItem('refresh-token', resp.refresh_token);
          // this.router.navigate(['/app/import']);
          this.redirectToFirstAllowedAccess();
        } else {
          this.errorMessage = 'Invalid username or password';
        }
      },
        error => {
          if (error.error) {
            this.errorMessage = error.error.error_description;
          } else {
            this.errorMessage = 'Invalid username or password';
          }
        });
    }

  }

  redirectToFirstAllowedAccess() {
    this.links = this.sharedService.accessList();
    if (this.links.length > 0) {
      const link = '/app/'+ (this.links[0]).toLowerCase();
      this.router.navigate([link]);
    } else {
      this.router.navigate(['/app']);
    }
  }

}
